import { Field } from './field';

export class Forms {
  constructor(
    public customerForm: Field[] = [],
    public cosignerForm: Field[] = [],
    public vehicleForm: Field[] = [],
    public productForm: Field[] = [],
    public lienholderForm: Field[] = [],
    public addlienholderForm: Field[] = [],
    public lienholder: any = {},
  ) {
  }
}
